import React from 'react';
import { isAnyWorkerSource } from '@scale/shared/workerSlack/helpers';

const SlackChannelWorkerSources = (props: $FIXME) => {
  return (
    <>
      <div className="item-option-container">
        <label>Worker Sources: </label>
        <div className="worker-sources-container">
          {!isAnyWorkerSource(props.channel.workerSources) &&
            props.channel.workerSources.map((workerSource: string) => (
              <div
                key={workerSource}
                className={`worker-source-box-container  worker-source-box-${workerSource}`}
              >
                <div className="worker-source-box">
                  {workerSource === '' ? `No Worker Source (Crowd)` : workerSource}
                </div>
              </div>
            ))}
          {!!isAnyWorkerSource(props.channel.workerSources) && (
            <div className={`worker-source-box-container  worker-source-box-level-${null}`}>
              <div className="worker-source-box">All worker source</div>
            </div>
          )}
        </div>
      </div>
      <style>{`
        label {
          font-weight: 500;
          padding-right: 4px;
        }
        .worker-sources-container {
          display: flex;
          flex-wrap: wrap;
          max-width: 300px;
          margin-left: 8px;
        }
        .worker-source-box-container {
          border-radius: 32px;
          display: flex;
          justify-content: center;
          align-items: center;
          margin: 4px;
          border: 1px solid var(--color-RemoGray50);
        }
        .worker-source-box {
          padding: 4px 12px;
          white-space: nowrap;
        }
        .item-option-container {
          display: flex;
          flex-direction: row;
          align-items: center;
        }
      `}</style>
    </>
  );
};

export default SlackChannelWorkerSources;
